import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'entitytype'
})
export class EntitytypePipe implements PipeTransform {

  transform(entities: Array<any>, entityType?: number): any {
      if (entityType == null || entities == null) return entities;

      return entities.filter(function (entiry) {
          if (entiry.PartyRoleLookup != null )
              return entiry.PartyRoleLookup.SeqNo == entityType;
      })
  }

}
